export default __webpack_public_path__ + "static/media/banner.a558dd26.png";